
// @vue/component
export default {
  name: 'DashboardStatusIcon',
  props: {
    icon: {
      type: String,
      default: '',
    },
  },
};
